module.exports = __webpack_public_path__ + "static/media/tommasella.71ba069d.png";